
<component
  :is="as"
  :class="['linkable-item', { 'border-radius': borderRadius, 'hide-router-link-active': hideRouterLinkActive }]"
  v-bind="$attrs"
  v-on="$listeners"
>
  <slot />
</component>
